module.exports = __webpack_public_path__ + "static/media/vipps-macbook-vs-samsung-tables-room-small.60c8d52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/vipps-macbook-vs-samsung-tables-room-small.png
// module id = 378
// module chunks = 0